import { render, staticRenderFns } from "./BroadcastSchedule.vue?vue&type=template&id=08670e47&scoped=true"
import script from "./BroadcastSchedule.vue?vue&type=script&lang=js"
export * from "./BroadcastSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08670e47",
  null
  
)

export default component.exports